import React from "react";

import PaginaFotos from "../../../components/Fotos/PaginaFotos/index";

export default function EmTratamento() {

    return (<> <PaginaFotos titulo={"Em tratamento"} diretorio={"em_tratamento"} /> </>);
}
